// Import regenerator-runtime to support async/await
import "regenerator-runtime/runtime";
import React from "react";
import { OrgNode } from "./OrgNode";
import OrganizationChart from "@dabeng/react-orgchart";
import { useAsync } from "react-async";
import { AxiosEmployeeAPI, AxiosEmployeeManagerAPI } from "../../Api";
import { Loader } from "semantic-ui-react";

export const OrgChart = ({ employee_id }) => {
  const loadDataAsync = async (node) => {
    let data = [];
    try {
      const response = await AxiosEmployeeManagerAPI.getTeam(
        { employee_id: node.id },
        {},
      );
      data = response;
    } catch (error) {
      throw error;
    }
    return data.map((employee) => ({
      id: employee.id,
      name: employee.name,
      area: employee.current_area?.area.name,
      position: employee.current_position?.position.name,
    }));
  };

  const { data, isPending, error } = useAsync({
    promiseFn: AxiosEmployeeAPI.getById,
    watch: employee_id,
    employee_id: employee_id,
    expand: "_extra,name",
  });

  if (isPending) return <Loader active size={"big"} />;
  if (error) return <div>Erro ao carregar funcionário!</div>;
  if (data) {
    const dataSource = {
      id: data.id,
      name: data.name,
      area: data.current_area?.area.name,
      position: data.current_position?.position.name,
    };
    return (
      <OrganizationChart
        datasource={dataSource}
        chartClass="lazyload-chart customChart"
        NodeTemplate={OrgNode}
        loadOnDemand={true}
        loadData={loadDataAsync}
        pan={true}
        zoom={true}
        zoomoutLimit={0.2}
        exportButton={true}
        exportFileextension="pdf"
        exportFilename="orgChart"
      />
    );
  }
};
